import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { CustomTableSelectComponent } from 'src/app/components/custom-table-select/custom-table-select.component';
import { ActionColor, CheckBoxAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { UpdateCostCenterPriceDetailModel } from 'src/app/models/others/update-cost-center-price-detail.model';
import { UpdateCostCenterPriceModel } from 'src/app/models/others/update-cost-center-price.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { CostCenterSelectionTableModel } from 'src/app/models/tables/archive/cost-center-selection-table.model';
import { UpdateCostCenterPriceDetailCaptureTableModel } from 'src/app/models/tables/others/update-cost-center-price-detail-capture-table.model';
import { UpdateCostCenterPriceDetailService } from 'src/app/services/others/update-cost-center-price-detail.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-update-cost-center-price-detail',
  templateUrl: './update-cost-center-price-detail.component.html',
  styleUrls: ['./update-cost-center-price-detail.component.scss'],
  standalone: false
})
export class UpdateCostCenterPriceDetailComponent implements OnInit {

  @ViewChild('costCenter') costCenterModalComponent?: CustomModalComponent | null = null;
  @Input() disabledDetail: boolean = false;
  @Input() updateCostCenterPriceModel: UpdateCostCenterPriceModel = new UpdateCostCenterPriceModel();
  @Output() emitQuantityDetails = new EventEmitter<number>();

  ascendant: boolean = true;
  ascendantCostCenter: boolean = true;
  checkboxActions: CheckBoxAction[] = [
    {
      label: 'Eliminar',
      icon: 'pi pi-trash',
      color: ActionColor.DANGER,
      action: 'bulk-delete'
    },
  ];
  clearSelectionTrigger: number = 0;
  columnSort: string | null = null;
  columnSortCostCenter: string | null = null;
  component = CustomTableSelectComponent;
  dataCostCenter: PagedResponseModel<CostCenterSelectionTableModel> = new PagedResponseModel<CostCenterSelectionTableModel>();
  detailData: PagedResponseModel<UpdateCostCenterPriceDetailCaptureTableModel> =
    new PagedResponseModel<UpdateCostCenterPriceDetailCaptureTableModel>();
  detailHeader: ColumnResponseModel[] = [];
  disabledButton: boolean = false;
  filtersCostCenter: ColumnResponseModel[] = []
  headerCostCenter: ColumnResponseModel[] = [];
  isFormView: boolean = false;
  inputsForCostCenter$ = new BehaviorSubject<any>({
    headers: [],
    data: [],
    showCheckbox: true,
    showRecover: true,
    isMultipleSelect: true,
    filters: [],
  })
  limit: number = 10;
  limitCostCenter: number = 10;
  output$ = new Subject<any>();
  page: number = 1;
  pageCostCenter: number = 1;
  subscription: Subscription;
  updateCostCenterPriceDetail: UpdateCostCenterPriceDetailModel = new UpdateCostCenterPriceDetailModel();
  updateCostCenterPriceDetails: UpdateCostCenterPriceDetailModel[] = [];

  constructor(private updateCostCenterPriceDetailService: UpdateCostCenterPriceDetailService,
    private toastHandlerService: ToastHandlerService) { }

  async ngOnInit() {
    await this.getColumnsForDetailCapture();
    this.subscription = this.output$.subscribe(({ type, payload }) => {
      switch (type) {
        case 'onPageChange':
          this.onPageChangeCostCenter(payload);
          break;
        case 'onFilterChange':
          this.onFilterChangeCostCenter(payload);
          break;
        default:
          console.warn('Tipo de evento desconocido:', type);
      }
    });
  }

  async ngOnChanges(changes: SimpleChanges) {
    const updateCostCenterPriceModel = changes["updateCostCenterPriceModel"];
    if (updateCostCenterPriceModel && !updateCostCenterPriceModel.firstChange) {
      this.clearSelectionTrigger++;
      this.getFormView(false);
      await this.getUpdateCostCenterPriceDetailsForCaptureTable();
    }
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  async createUpdateCostCenterPriceDetail(updateCostCenterPriceDetails: UpdateCostCenterPriceDetailModel[]) {
    try {
      await firstValueFrom(this.updateCostCenterPriceDetailService.createDetails(updateCostCenterPriceDetails));
      await this.getUpdateCostCenterPriceDetailsForCaptureTable();
      this.toastHandlerService.showToast('success', `El detalle de la actualización de precios por c.costos fue creado exitosamente.`);
    } catch (error) {
      console.error('Error al crear el detalle de actualización de precios por c.costos.', error);
    }
  }

  async deleteUpdateCostCenterPriceDetail(selectedIds: number[]) {
    if (selectedIds.length === 0) return;
    const result = await Swal.fire({
      title: 'Atención',
      text: "¿Realmente desea eliminar el detalle de la actualización de precios por c.costos?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    });
    if (result.isConfirmed) {
      try {
        await firstValueFrom(this.updateCostCenterPriceDetailService.deleteSomeDetailsAsync(selectedIds));
        this.clearSelectionTrigger++;
        await this.getUpdateCostCenterPriceDetailsForCaptureTable();
        this.toastHandlerService.showToast('success', 'El detalle de la actualización de precios por c.costos fue eliminado exitosamente.');
      } catch (error) {
        console.error('Error al eliminar detalles de actualización de precios por c.costos.', error);
      }
    }
  }

  async getColumnsForCostCenter() {
    try {
      if (this.headerCostCenter.length === 0) {
        const response = await firstValueFrom(this.updateCostCenterPriceDetailService.getColumnsForCostCenters());
        this.headerCostCenter = response;
        this.updateInputs()
      }
    } catch (error) {
      console.error('Error al obtener las columnas para la tabla de selección de centros de costos.', error);
    }
  }

  async getColumnsForDetailCapture() {
    try {
      if (this.detailHeader.length === 0) {
        const response = await firstValueFrom(this.updateCostCenterPriceDetailService.getColumnsForCaptureTable());
        this.detailHeader = response;
      }
    } catch (error) {
      console.error('Error al obtener las columnas para la tabla de captura de actualización de precios por c.costos.', error);
    }
  }

  getFormView(isFormView: boolean) {
    this.isFormView = isFormView;
  }

  async getAllCostCenterSelection() {
    try {
      const response = await firstValueFrom(this.updateCostCenterPriceDetailService.getAllCostCenters(this.pageCostCenter,
        this.limitCostCenter, this.columnSortCostCenter, this.ascendantCostCenter, this.filtersCostCenter));
      this.dataCostCenter = response;
      this.updateInputs();
    } catch (error) {
      console.error('Error al obtener los centros de costos', error);
    }
  }

  async getUpdateCostCenterPriceDetailsForCaptureTable() {
    try {
      this.detailData = await firstValueFrom(
        this.updateCostCenterPriceDetailService.getUpdateCostCenterPriceDetailsForCaptureTable(
          this.page, this.limit, this.columnSort, this.ascendant, this.updateCostCenterPriceModel.updateCostCenterPriceId
        )
      );
      this.emitQuantityDetails.emit(this.detailData.totalItems);
    } catch (error) {
      console.error('Error al consultar los detalles de actualización de precios por C.Costos. ', error);
    }
  }

  async handleSelectedItem(selectedItem: any) {
    const newDetails = selectedItem.map((element: {
      costCenterId: number
    }) => {
      const newUpdateCostCenterPriceDetail = new UpdateCostCenterPriceDetailModel();
      newUpdateCostCenterPriceDetail.updateCostCenterPriceId = this.updateCostCenterPriceModel.updateCostCenterPriceId;
      newUpdateCostCenterPriceDetail.costCenterId = element.costCenterId;
      return newUpdateCostCenterPriceDetail;
    });
    await this.createUpdateCostCenterPriceDetail(newDetails);
  }

  async onAction(event: { action: string, item?: UpdateCostCenterPriceDetailModel, selectedItems?: number[] }) {
    if (event.action === 'bulk-delete' && event.selectedItems) {
      await this.deleteUpdateCostCenterPriceDetail(event.selectedItems);
    }
  }

  async onFilterChangeCostCenter(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filtersCostCenter = this.removeDuplicates(filters);
    this.filtersCostCenter.forEach((filter: any) => this.processFilter(filter));
    this.updateInputs();
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField || null;
    this.ascendant = event.sortOrder === 1;
    await this.getUpdateCostCenterPriceDetailsForCaptureTable();
  }

  async onPageChangeCostCenter(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    this.pageCostCenter = event.page;
    this.limitCostCenter = event.pageSize;
    this.columnSortCostCenter = event.sortField || null;
    this.ascendantCostCenter = event.sortOrder === 1;
    await this.getAllCostCenterSelection();
  }

  async openCostCenterModal() {
    this.filtersCostCenter = [];
    this.updateInputs();
    await Promise.all([
      this.getColumnsForCostCenter(),
      this.getAllCostCenterSelection()
    ]);
    this.costCenterModalComponent?.show();
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filtersCostCenter = this.filtersCostCenter.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filtersCostCenter.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  updateInputs() {
    this.inputsForCostCenter$.next({
      headers: this.headerCostCenter,
      data: this.dataCostCenter,
      showCheckbox: true,
      showRecover: true,
      isMultipleSelect: true,
      filters: this.filtersCostCenter,
    });
  }
}
